<template>
    <div>
        <v-row>
            <v-col><v-icon @click="dialog = true" color="primary">mdi-brush-outline</v-icon></v-col>
            <v-col class="text-end">

                <!-- Button group to toggle between Horizontal and Vertical views -->
                <v-btn-toggle v-model="selectedChart" class="mb-4" mandatory shaped>
                    <v-btn value="chart1">{{$t('ChartOne')}}</v-btn>
                    <v-btn value="chart2">{{$t('ChartTwo')}}</v-btn>
                    <v-btn value="chart3">{{$t('ChartThree')}}</v-btn>
                    <v-btn value="chart4">{{$t('ChartFour')}}</v-btn>
                    <v-btn value="chart5">{{$t('ChartFive')}}</v-btn>
                </v-btn-toggle>
            </v-col>
            

        </v-row>
        <v-dialog v-model="dialog" persistent max-width="500px">
            <v-card>
                <div class="card-title">
                    {{ $t('ChangeColor')}}
                </div>
                <v-card-title></v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" md="4" v-for="(item, index) in value"
                               :key="index">
                            <v-color-picker v-model="item.color"
                                            mode="hexa"></v-color-picker>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="dialog = false" text>{{$t('Close')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Horizontal layout -->
        <v-row v-if="selectedChart === 'chart1'">
            <v-col>
                <template>
                    <v-container>
                        <v-row>
                            <v-col cols="auto">
                                <v-card outlined class="pa-4 text-center" style="position:relative">
                                    <canvas :id="'chartthree-1'" style="max-width: 200px; margin: auto;"></canvas>
                                    <!--<img src="/building.png" style="width:70px;top:70px;left:110px;position:absolute" />-->
                                </v-card>
                            </v-col>
                            <v-col cols="12" md="6" lg="4">
                                <div class="backone">
                                    <div class="title">{{$t('OverAllSatisfaction')}}</div>
                                    <div class="text">{{publicsatisfactoryPerc}}%</div>
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>
                </template>
            </v-col>
        </v-row>

        <!-- Vertical layout -->
        <v-row v-if="selectedChart === 'chart2'">
            <v-col>

                <v-row class="d-flex align-center justify-space-between " style="background-color: #efeded; border-radius: 8px;">
                    <v-col cols="auto" style="position:relative">

                        <div :style="'width:200px;height:100px;background-image:url(/satisfactiontitle2.png);background-size:contain;background-repeat:no-repeat;background-position:top center'">
                            <table style="width:94%">
                                <tr>
                                    <td style="text-align:center;font-size:12px;color:white;padding-top:30px;width:65%">{{$t('OverAllSatisfaction')}}</td>
                                    <td style="font-weight: 700; text-align: center; font-size: 20px; color: #5EBFCE; padding-top: 30px">{{publicsatisfactoryPerc}}%</td>
                                </tr>
                            </table>
                        </div>
                    </v-col>
                </v-row>
                <v-row>

                    <!-- Satisfaction Levels with Vertical Bars -->
                    <v-col cols="8" class="d-flex justify-center">
                        <v-row>
                            <v-col v-for="(item, index) in value"
                                   :key="index"
                                   class="text-center d-flex flex-column align-center">
                                <div style="background-color:white;border-radius:50px;width:100px;padding:0 0px 10px 0px;text-align:center;height:250px">
                                    <img :src="`face${item.id}.png`" style="width:100%" /><br /><br /><br />
                                    <span :style="`color:${item.color};font-weight:700;font-size:25px`">{{item.percentage}}%</span><br /><br />
                                    <span>{{ item.level }} </span>
                                </div>

                            </v-col>
                        </v-row>
                    </v-col>

                </v-row>

            </v-col>
        </v-row>
        <v-row v-if="selectedChart === 'chart3'">
            <v-col>

                <v-row class="d-flex align-center justify-space-between " style="background-color: #efeded; border-radius: 8px;">
                    <v-col><img src="/threepeople.png" style="width:100px" /></v-col>
                    <v-col v-for="(item, index) in value"
                           :key="index">
                        <div style="background-color:white;border-radius:10px;padding:10px">
                            <table style="width:100%"><tr><td><img :src="`face${item.id}.png`" style="width:50px" /></td><td></td><sup>({{item.count}})</sup><td><span :style="`color:${item.color };font-size:26px;font-weight:700`">{{item.percentage}}%</span><br />{{item.level}}</td></tr></table>
                        </div>
                    </v-col>
                </v-row>


            </v-col>

        </v-row>
        <v-row v-if="selectedChart === 'chart4'">
            <v-col>

                <v-row v-for="(item, index) in value"
                       :key="index">
                    <v-col cols="4" class="text-center" style="position:relative"><div :style="`width:5px;background-color:${ item.color};position:absolute;height:80%;border-radius:0px 10px 10px 0`"></div><img :src="`face${item.id}.png`" style="width:50px" /></v-col>
                    <v-col cols="4" class="text-center mt-2">{{item.level}}</v-col>
                    <v-col cols="4" class="text-center mt-2" style="position:relative"><div :style="`background-color:${ item.color};color:white;text-align:center;width:100px;height:35px;line-height:35px;border-radius:17px;margin:auto`">{{item.percentage}}%</div><div :style="`width:3px;background-color:${ item.color};position:absolute;height:80%;left:0px;top:0px`"></div></v-col>
                </v-row>

            </v-col>
        </v-row>
        <v-row v-if="selectedChart === 'chart5'">
            <v-col>

                <v-row>
                    <v-col cols="3">
                        <div class="white--text text-center" style=" background: linear-gradient(180deg, rgba(47,160,169,1) 0%, rgba(47,160,169,1) 35%, rgba(90,198,206,1) 100%); height: 300px;line-height:300px;border-radius:20px; background-size: contain; background-repeat: no-repeat; padding: 0px 10px;width:100%">
                            {{$t('BeneficiarySatisfaction')}}
                        </div>
                    </v-col>
                    <!-- Bubble Chart -->
                    <v-col cols="4">
                        <div class="circle-container">
                            <div v-for="(circle, index) in value"
                                 :key="index"
                                 :style="getCircleStyle(circle)"
                                 class="circle d-flex align-center justify-center">
                                <span>{{ circle.percentage }}%</span>
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="3" class="d-flex align-center">
                        <v-list dense>
                            <v-list-item v-for="(item, index) in value" :key="index" class="px-0">
                                <v-list-item-icon>
                                    <v-icon :color="item.color">mdi-circle</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{ item.level }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-col>

                </v-row>

            </v-col>
        </v-row>
    </div>
</template>

<script>
    import { Chart, ArcElement, Tooltip, Legend, Plugin, PointElement } from 'chart.js'


    export default {
        props: {
            value: {
                type: Array,
                default: () => [],
            },

        },
        data() {
            return {
                instance: null,
                selectedChart: 'chart1', // Default to horizontal view
                legend: [
                    { text: 'راضي', color: '#64DD17' },
                    { text: 'محايد', color: '#FFEB3B' },
                    { text: 'غير راضي', color: '#FF6D00' },
                ],
                // Chart data
                bubbleData: [
                    { x: 1, y: 1, r: 63, color: '#64DD17' }, // Satisfied
                    { x: 2, y: 2, r: 29, color: '#FFEB3B' }, // Neutral
                    { x: 3, y: 3, r: 20, color: '#FF6D00' }, // Unsatisfied
                ],
                dialog:false
            }
        },
        mounted() {
            Chart.register(ArcElement, Tooltip, Legend, PointElement)

            this.renderChartOne()
        },
        watch: {
            selectedChart: {
                handler: function (val, oldVal) {
                    if (this.selectedChart == 'chart1') {

                        this.renderChartOne()
                    }


                },
                deep: true
            },
            value: {
                handler: function (val, oldVal) {
                    if (this.selectedChart == 'chart1') {

                        this.renderChartOne()
                    }


                },
                deep: true
            }
        },
        computed: {
            publicsatisfactoryPerc() {

                var five = this.value.filter(x => x.id == 5)

                var satisfactory = 0
                if (five.length > 0)
                    satisfactory += five[0].percentage

                return satisfactory
            },
            publicsatisfactoryTotal() {
                var satisfactory = 0
                for (var i = 0; i < this.value.length; i++) {
                    satisfactory += this.value[i].count
                }
                return satisfactory
            }

        },

        methods: {
            getCircleStyle(circle) {
                const minSize = 50 // Minimum size for small percentages
                const maxSize = 150 // Maximum size for large percentages
                const size = Math.max((circle.percentage / 100) * maxSize, minSize)
                return {
                    backgroundColor: circle.color,
                    width: `${size}px`,
                    height: `${size}px`,
                    fontSize: `${size / 5}px`,
                }
            },
            renderChartOne() {


                var colors = []
                var data = []
                for (var i = 0; i < this.value.length; i++) {
                    colors.push(this.value[i].color)
                    data.push(this.value[i].count)
                }
                if (document.getElementById('chartthree-1')) {
                    const ctx = document.getElementById('chartthree-1').getContext('2d')


                    if (this.instance) {
                        this.instance.destroy()
                    }

                    this.instance = new Chart(ctx, {
                        type: 'doughnut',
                        data: {
                            labels: this.value.map((label) => label.level),
                            datasets: [
                                {
                                    data: data,

                                    backgroundColor: colors
                                },
                            ],
                        },
                        options: {
                            cutout: '80%',
                            plugins: {
                                tooltip: { enabled: true },
                                legend: { display: false },
                               
                            },
                        },
                    })
                }

            }
        },
    }
</script>

<style scoped>
    .text-center {
        text-align: center;
    }

    .text-right {
        text-align: right;
    }

    .text-caption {
        font-weight: bold;
        background-color: #eef0f2;
        padding: 5px;
        border-radius: 5px;
    }

    .bar-container {
        height: 150px;
        width: 30px;
        background-color: #eef0f2;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        border-radius: 4px;
    }

    .bar {
        width: 100%;
        border-radius: 4px;
    }

    .chart3 {
        width: 50px;
        height: 300px;
        position: relative
    }

    .chart4 {
        width: 50px;
        height: 200px;
        position: relative;
        border-radius: 20px;
        border: 5px solid white;
    }

        .chart4 .bar {
            border-radius: 10px;
        }

    .d-flex {
        display: flex;
    }

    .align-center {
        align-items: center;
    }

    .flex-column {
        flex-direction: column;
    }

    .rotated-text {
        display: inline-block; /* Ensures the rotation works properly */
        transform: rotate(270deg); /* Rotates text by 45 degrees */
        transform-origin: center; /* Sets the point around which the text is rotated */
        position: absolute;
        bottom: 100px;
        width: 280px;
        font-weight: 700
    }

    .backone {
        background-color: white;
        border-radius: 25px;
        height: 150px;
        width: 150px;
        border: 1px solid #33A1AA;
    }

        .backone .title {
            background-image: url(/public/triplesatchartonetitle.png);
            background-size: 100%;
            background-repeat: no-repeat;
            height: 60px;
            line-height: 50px;
            color: white;
            text-align: center;
            font-size: 14px !important;
        }

        .backone .text {
            color: #33A1AA;
            text-align: center;
            font-size: 26px;
            padding-top: 20px;
        }

    .circle-container {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-around;
        gap: 10px;
    }

    .circle {
        border-radius: 50%;
        color: white;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: bold;
    }
</style>
